import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BaseLayout from '../Layout/BaseLayout';
import HeaderVectorLeft from '../icons/HeaderVectorLeft';
import HeaderVectorRight from '../icons/HeaderVectorRight';
import { incrementStep } from '../features/FormRegistration';

function Step7() {
  const dispatch = useDispatch();

  // Use useEffect to increment step after 3 seconds
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     if (isTestMode) {
  //       dispatch(incrementStep());
  //     }
  //   }, 3000);

  //   // Cleanup the timer on component unmount
  //   return () => clearTimeout(timer);
  // }, [dispatch]);

  //  Disable test mode for production release
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(incrementStep());
    }, 3000);
    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, [dispatch]);

  return (
    <BaseLayout>
      <div className="flex flex-col items-center">
        <div
          className="w-full h-[318px] flex items-center justify-center relative"
          style={{
            background: 'linear-gradient(86deg, #CD232E 32.8%, #89C3F1 98.05%)',
            overflow: 'hidden',
          }}>
          <span className="text-[28px] md:text-[38px] text-[white] font-medium z-[999]">
            Generating Matching Policies...
          </span>
          <div className="absolute left-[-160px] bottom-[-100px] md:left-[27px] md:bottom-[-50px]">
            <HeaderVectorLeft />
          </div>
          <div className="absolute md:right-[0px] md:top-[-70px] right-[-170px] top-[-70px]">
            <HeaderVectorRight />
          </div>
        </div>
        <div className="flex flex-col mt-[42px] gap-[28px] w-full md:w-[600px] px-[20px]">
          {/* <div className="flex flex-col">
            <span className="text-[15px] font-medium">
              Here is your reference number
            </span>
            <span className="text-[20px] font-medium">#{leadRefNumber}</span>
          </div> */}

          <p className="text-[16px] font-normal">
            Thank you for comparing health insurance with us! One of our
            friendly team members will be in touch soon to discuss the available
            options and help you find the best deal that suits your needs.
          </p>
          <div className="flex flex-col">
            <span className="text-[15px]">Contact us on</span>
            <span className="text-[20px] font-normal">1300 369 399</span>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}

export default Step7;
